import { whoAmIResponse } from "../models/project";
import { API_URL } from "./apiBase";

export async function whoAmI(
    accessToken: string | null
): Promise<whoAmIResponse> {
    return fetch(`${API_URL}/user/whoami`, {
        method: "GET",
        headers: {
            Authorization: `Bearer ${accessToken}`,
        },
    }).then((res) => res.json());
}
